import { useIntl } from 'react-intl';
import { welcomeBgIcon } from '@marketplace/ui-elements';
import classes from './no-applications.module.scss';

export const NoApplications = (): JSX.Element => {
  const { formatMessage } = useIntl();
  return (
    <div className={classes.wrapper}>
      <div className={classes.text_wrapper}>
        <h3 className={classes.title}>
          {formatMessage({
            id: 'developer_welcome_banner_title',
          })}
        </h3>
        <p className={classes.text}>
          {formatMessage({
            id: 'developer_welcome_banner_text',
          })}
        </p>
      </div>
      <div className={classes.img_wrapper}>
        <img src={welcomeBgIcon} alt="" />
      </div>
    </div>
  );
};
